<template>
    <div id="home">
        <Intro/>
        <AboutUs/>
        <Projects/>
        <Publications/>
        <Datasets/>
        <Funding/>
        <Members/>
        <ContactUs/>
    </div>
</template>

<script>
    import Intro from "./Intro";
    import AboutUs from "./AboutUs";
    import Projects from "./Projects";
    import Publications from "./Publications";
    import Footer from "./Footer";
    import Members from "./Members";
    import Funding from "./Funding";
    import ContactUs from "./ContactUs";
    import Datasets from "./Datasets";
    import ExcelJS from "exceljs";

    const BACKEND_API = "https://corsroute.wpi.edu";
    // const BACKEND_API = "http://localhost:8091";


    function _arrayBufferToBase64(buffer) {
        var binary = '';
        var bytes = new Uint8Array(buffer);
        var len = bytes.byteLength;
        for (var i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
    }

    function assignImage(workbook, wsImage) {
        try {
            var image = null
            for (let i = 0; i < workbook.media.length; i++) {
                if (workbook.media[i].index === wsImage.imageId) {
                    image = workbook.media[i]
                    break;
                }
            }
            let base64String = _arrayBufferToBase64(image.buffer);
            return "data:image/" + image.extension + ";charset=utf-8;base64," + base64String
        } catch (e) {
            return null;
        }
    }

    export default {
        name: 'Home',
        components: {
            Intro,
            AboutUs,
            Projects,
            Publications,
            Datasets,
            Members,
            Funding,
            ContactUs,
            // Footer
        },
        data() {
            return {
                projects: [],
                publications: [],
                membersARL: {},
                membersWPI: {},
                funding: [],
                projectCount: null,
                publicationCount: null,
                memberCount: null
            }
        },
        mounted() {

            // Members
            this.$http.get(BACKEND_API + '/members').then((response) => {
                let memberData = response.data;
                let keys = Object.keys(memberData);
                keys.forEach(key => {
                    if (memberData[key].team === 'WPI') {
                        this.$set(this.membersWPI, memberData[key].name, memberData[key]);
                    } else if (memberData[key].team === 'ARL') {
                        this.$set(this.membersARL, memberData[key].name, memberData[key]);
                    }
                })
            });

            // Projects
            this.$http.get(BACKEND_API + '/projects').then((response) => {
                this.projects = response.data;
            });

            // Publications
            this.$http.get(BACKEND_API + '/publications').then((response) => {
                this.publications = response.data;
            });

            // Funding
            this.$http.get(BACKEND_API + '/funding').then((response) => {
                this.funding = response.data;
            });

            // Stats
            this.$http.get(BACKEND_API + '/stats').then((response) => {
                this.projectCount = response.data.projectCount;
                this.publicationCount = response.data.publicationCount;
                this.memberCount = response.data.memberCount;
            });
        }
    }
</script>

<style>
    @import url('https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap');

    #home {
        /*font-family: Avenir, Helvetica, Arial, sans-serif;*/
        /*-webkit-font-smoothing: antialiased;*/
        /*-moz-osx-font-smoothing: grayscale;*/
        /*text-align: center;*/
        /*color: #2c3e50;*/
        /*margin-top: 60px;*/
    }

    .section-header-top {
        letter-spacing: 5px;
        text-transform: uppercase;
        opacity: 0.8;
    }

    .readable-text {
        letter-spacing: 0.07em;
        line-height: 1.6em;
    }

    .hr-bold {
        border-top: 2px solid rgba(0, 0, 0, .1);
    }

    .hr-light {
        border-top: 2px solid rgba(255, 255, 255, .3);
    }

    .gradient {
        background: -moz-linear-gradient(45deg, rgba(42, 27, 161, 0.7), rgba(29, 210, 177, 0.7) 100%);
        background: -webkit-linear-gradient(45deg, rgba(42, 27, 161, 0.7), rgba(29, 210, 177, 0.7) 100%);
        background: -webkit-gradient(linear, 45deg, from(rgba(42, 27, 161, 0.7)), to(rgba(29, 210, 177, 0.7)));
        background: -o-linear-gradient(45deg, rgba(42, 27, 161, 0.7), rgba(29, 210, 177, 0.7) 100%);
        background: linear-gradient(45deg, rgba(42, 27, 161, 0.7), rgba(29, 210, 177, 0.7) 100%);
    }

</style>
